import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 親ID
 */
export class ParentId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): ParentId {
    const regex = new RegExp(this.validationRule.pattern.value);
    if (!regex.test(value)) {
      throw new Error(this.validationRule.pattern.message);
    }
    return new ParentId(value);
  }

  /** ラベル */
  static get label(): string {
    return 'ユーザーID';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return 'taro';
  }

  /** タイプ */
  static get type() {
    return 'text';
  }

  /** キー */
  static get key() {
    return 'parentId';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
      /** パターン */
      pattern: {
        /** 値 */
        value: /^([a-zA-Z0-9.]){3,256}$/,
        /** メッセージ */
        message: '3文字以上かつ256文字以下かつアルファベット小文字、大文字、数字である必要があります',
      },
    };
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
